import { MenuItem, Select, TextField , Button,} from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useAddQueryContactUsMutation } from "../../../redux/services/contactUsApi";
import { useEffect, useState } from "react";
import MuiAlert from "../../MuiAlert/MuiAlert";
import { useGetEnumDataMutation } from "../../../redux/services/enumApi";
import Loading from "../../commons/Loading";
import { useNavigate } from "react-router-dom";
import RegularButton from "../../../components/Buttons/RegularButton";
import { useFindCustomerDetailByIdMutation } from "../../../redux/services/customerService";
import { getUserData } from "../../../redux/slices/authSlice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/app/hooks";
import { setCustomer } from "../../../redux/slices/customerSlice";
import { useUpdateCustomerDetailMutation } from "../../../redux/services/customerService";
import contactImage from "../../../assets/Sidebar (2).png";
type Props = {};

const contactFormSchema = Yup.object().shape({
  emailId: Yup.string().email().required("Email is required").trim(),
  reason: Yup.string().required("Reason is required").trim(),
  description: Yup.string().required("Description is required").trim(),
});

const Contactsupport = (props: Props) => {
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const customerId = currentUser?.customerId;
  const customerDetail: any = JSON.parse(
    localStorage.getItem("customerDetail") || "{}"
  );
  const [findById, findByIdResponse] = useFindCustomerDetailByIdMutation();
  const userData = useSelector(getUserData);
  const userToken: string = currentUser?.jwtToken;
  const navigate = useNavigate();
  const [contactSupport, contactSupportResponse] =
    useAddQueryContactUsMutation();
  const [statusCodes, setStatusCodes] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  const [reason, setReason] = useState([]);
  const [char, setChar] = useState(0);
  const [touchedEmail, setTouchedEmail] = useState(false);
  const [formValues, setFormValues] = useState({
    emailId: "",
    reason: "",
    description: "",
  });

  useEffect(() => {
    getEnumData({});
  }, []);

  useEffect(() => {
    if (userData) {
      findById({ token: token, id: customerId });
    }
  }, []);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      setReason(enumResponse?.data?.CONTACT_SUPPORT);
    } else if (enumResponse.isError) {
    }
  }, [enumResponse.isSuccess, enumResponse.isError]);

  const handleSubmitForm = (values: any) => {
    contactSupport({
      payload: {
        email: values.emailId,
        contactType: values.reason,
        description: values.description,
        status: true,
      },
    });
  };

  useEffect(() => {
    if (contactSupportResponse.isSuccess) {
      setStatusCodes({ type: "success", code: "CONSENT_FORM_SUCCESS" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    } else if (contactSupportResponse.isError) {
      let errorData: any = contactSupportResponse.error;
      let errorMessage = errorData.error || errorData.data.serviceErrors[0].msg;
      if (errorMessage === "Query Contact already Present.") {
        setStatusCodes({ type: "error", code: "REQUEST_EXIST_ERROR" });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      } else if (
        errorMessage === "User not found. Please contact service desk."
      ) {
        setStatusCodes({ type: "error", code: "USER_NOT_EXISTS" });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      } else {
        setStatusCodes({ type: "error", code: "CONSENT_FORM_ERROR" });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      }
    }
  }, [contactSupportResponse.isSuccess, contactSupportResponse.isError]);

  const handleChangeChar = (e: any) => {
    const data = e.target.value.split("");
    if (data.length <= 200) {
      setChar(data.length);
    }
  };

  return (
    <div>
      <div className=" rounded-[8px] bg-[#F9F4EF] lg:mx-[20px] m-[20px]  mx-2 md:p-[20px] p-[8px] lg:p-[30px] ">
        {enumResponse.isLoading ? <Loading /> : null}
        <div className="col-span-9 content-center items-center justify-center mr-30 ">
          {isAlertVisible && (
            <div>
              <MuiAlert
                severity={statusCodes?.type!}
                messageType={statusCodes?.code!}
              />
            </div>
          )}
          <p className="text-[#434343] font-bold lg:text-[25px] text-[20px] ml-6">
            Contact Support
          </p>
          <div className="flex lg:flex-row flex-col lg:w-full justify-center lg:justify-items-start justify-items-center lg:p-0 md:p-5">
            <div className="flex flex-col  w-[100%] md:p-6 p-2 ">
              <Formik
                validationSchema={contactFormSchema}
                initialValues={formValues}
                onSubmit={handleSubmitForm}
              >
                {({
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  handleReset,

                  values,
                  touched,
                  errors,
                }) => (
                  <div>
                    <div className="flex flex-col lg:flex-row lg:gap-4 lg:w-[100%]">
                    {/* Email ID Field */}
                    <div className="flex flex-col flex-1 mt-3 gap-1">
                      <label className="text-black font-semibold text-sm">Email ID</label>
                      <TextField
                          variant="outlined"
                          color="error"
                          size="small"
                          id={"emailId"}
                          name={"emailId"}
                          type="email"
                          value={values.emailId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none overflow-hidden whitespace-nowrap text-ellipsis"
                          sx={{
                            "& .MuiInputBase-root, & .MuiOutlinedInput-root": { all: "unset" },
                            "& .MuiInputBase-input, & .MuiOutlinedInput-input": { all: "unset" },
                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                            "& .Mui-disabled": { color: "#9CA3AF", cursor: "not-allowed", opacity: 1, pointerEvents: "none" },
                            "& .Mui-disabled .MuiInputBase-input": { backgroundColor: "#E5E7EB" },
                            "& .MuiInputLabel-root.Mui-disabled": { backgroundColor: "transparent" },
                          }}
                        />
                      <div className="text-red-500 text-xs">{errors.emailId}</div>
                    </div>

                    {/* Select Reason Field */}
                    <div className="flex flex-col flex-1 mt-3 gap-1">
                      <label className="text-black font-semibold text-sm">Select reason</label>
                      <Select
                          color="error"
                          size="small"
                          id={"reason"}
                          name={"reason"}
                          value={values.reason}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Select Reason"
                          className="rounded-full bg-gray-200"
                            sx={{
                              "& .MuiInputBase-root": {
                                backgroundColor: "#E5E7EB",
                                borderRadius: "999px",
                              },
                              "& .MuiOutlinedInput-root": { 
                                display: "flex",
                                alignItems: "center",
                              },
                              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                              "& .Mui-disabled": { color: "#9CA3AF", cursor: "not-allowed", opacity: 1, pointerEvents: "none" },
                              "& .Mui-disabled .MuiInputBase-input": { backgroundColor: "#E5E7EB" },
                              "& .MuiInputLabel-root.Mui-disabled": { backgroundColor: "transparent" },
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  borderRadius: "12px", 
                                  overflow: "hidden",
                                }
                              }
                            }}
                          displayEmpty
                          defaultValue={"hii"}
                        >
                          {reason &&
                            reason.map((reason: any) => (
                              <MenuItem value={reason.code} key={reason.code}>
                                {reason.displayValue}
                              </MenuItem>
                            ))}
                        </Select>
                      <div className="text-red-500 text-xs">{errors.reason}</div>
                    </div>
                  </div>

                  {/* Description Field */}
                  <div className="flex flex-col mt-3 gap-1 w-full">
                    <label className="text-black font-semibold text-sm">Description</label>
                    <div className="relative">
                    <TextField
                          color="error"
                          variant="outlined"
                          size="small"
                          placeholder="Enter description"
                          id={"description"}
                          name={"description"}
                          value={values.description}
                          onChange={handleChange}
                          onKeyUp={(e) => handleChangeChar(e)}
                          multiline
                          rows={3}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 200 }}
                          className="rounded-2xl bg-gray-200 p-2"
                          sx={{
                            "&.MuiFormControl-root": { width: "100% !important" },
                            "& .MuiTextField-root": { width: "100% !important" }, 
                            "& .MuiInputBase-root": {
                              width: "100% !important", 
                              backgroundColor: "#E5E7EB",
                              borderRadius: "999px",
                            },
                            "& .MuiOutlinedInput-root": { 
                              width: "100% !important", 
                              display: "flex",
                              alignItems: "center",
                            },
                            "& .MuiOutlinedInput-input": {
                              width: "100% !important", 
                            },
                            "& .MuiOutlinedInput-notchedOutline": { border: "none" }, 
                            "& .Mui-disabled": { color: "#9CA3AF", cursor: "not-allowed", opacity: 1, pointerEvents: "none" },
                            "& .Mui-disabled .MuiInputBase-input": { backgroundColor: "#E5E7EB" },
                            "& .MuiInputLabel-root.Mui-disabled": { backgroundColor: "transparent" },
                          }}
                        />
                      <div className="absolute bottom-2 right-3 text-gray-500 text-xs">
                        {char}/200
                      </div>
                    </div>
                    <div className="text-red-500 text-xs">{errors.description}</div>
                  </div>

                  {/* Submit Button */}
                  <div className="w-full flex justify-center mt-4">
                    <Button
                      component="button"
                      className="h-8 w-24 bg-[#ED1C24] hover:bg-red-600 text-white font-bold text-md rounded-lg focus:outline-none"
                      sx={{
                        all: "unset", 
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleSubmit();
                      }}> Submit </Button>
                  </div>
                </div>
                )}
              </Formik>
            </div>
          </div>

        </div>
      </div>
      <div className="">
          <img src={contactImage} alt="offers" className="my-10"/>
      </div>         
    </div>
  );
};

export default Contactsupport;
